import { FilterData, FilterSourceData, FilterSourceItem } from "../typing";

const benefitsFilterFn = (data: FilterSourceItem, value: FilterData["benefits"]): boolean => {
  if (value.length === 0) {
    return true;
  }
  return value.includes(String(data.annual_fee));
};

const categoryFilterFn = (data: FilterSourceItem, value: FilterData["category"]): boolean => {
  if (value.length === 0) {
    return true;
  }
  return value.some((v) => data.categories.includes(Number(v)));
};

const bankProgramsFilterFn = (
  data: FilterSourceItem,
  value: FilterData["bankPrograms"]
): boolean => {
  if (value.length === 0) {
    return true;
  }
  return value.includes(String(data.bank));
};

const annualFeeFilterFn = (data: FilterSourceItem, value: FilterData["annualFee"]): boolean => {
  if (value === "-1") {
    return true;
  }

  if (value === "0") {
    return data.annual_fee === 0;
  }

  if (value === "1") {
    return data.annual_fee <= 100;
  }

  if (value === "2") {
    return data.annual_fee > 100;
  }
};

const minBonusAmountFilterFn = (
  data: FilterSourceItem,
  value: FilterData["minBonusAmount"]
): boolean => {
  if (!value || value < 0) {
    return true;
  }
  return Number(data.bonus) >= value;
};

const maxSpendingRequirementFilterFn = (
  data: FilterSourceItem,
  value: FilterData["maxSpendingRequirement"]
): boolean => {
  if (!value || value < 0) {
    return true;
  }
  return data.spending_requirement <= value;
};

const nameFilterFn = (data: FilterSourceItem, value: FilterData["name"]): boolean => {
  if (!value) {
    return true;
  }
  return data.name.toLowerCase().includes(value.toLowerCase());
};

/**
 * 根据过滤条件筛选数据源
 * @param list
 * @param filter
 * @returns
 */
export const useFilterList = (list: FilterSourceData, filter: FilterData): FilterSourceData => {
  return list.filter((item) => {
    return [
      benefitsFilterFn(item, filter["benefits"]),
      categoryFilterFn(item, filter["category"]),
      bankProgramsFilterFn(item, filter["bankPrograms"]),
      annualFeeFilterFn(item, filter["annualFee"]),
      minBonusAmountFilterFn(item, filter["minBonusAmount"]),
      maxSpendingRequirementFilterFn(item, filter["maxSpendingRequirement"]),
      nameFilterFn(item, filter["name"]),
    ].every(Boolean);
  });
};
